export class NotificationConstants {
  static readonly ERROR: string = "error";
  static readonly WARN: string = "warn";
  static readonly INFO: string = "info";
}
